import React, {CSSProperties} from "react"
import classNames from "classnames";
import styles from '../css/Icon.module.css'
import {rem} from "../utils/CSSUtils";

interface Props {
    name: string,
    white?: boolean,
    xs?: boolean,
    xl?: boolean,
    gray?: boolean,
    lightGray?: boolean,
    size?: number
}

export default (props: Props) => {

    const {name, white, size, xs, xl, lightGray, gray} = props;

    const style: CSSProperties = {};

    if (size) {
        style.width = rem(size);
        style.height = rem(size);
    }

    style.pointerEvents = 'none';

    return (
        <span style={style} className={classNames(styles.icon, name, {
            [styles.iconWhite]: white,
            [styles.iconXs]: xs,
            [styles.iconXl]: xl,
            [styles.iconGray]: gray,
            [styles.lightGray]: lightGray
        })}/>
    );

}
